<template>
  <div class="supreme-vip-dialog">
    <div class="supreme-vip-content" slot='custom' :style="`background-image: url(${data.icon});`">
      <nd-button class="apply-btn SKC_M caseId-SKC_M" @click="handleButtonClick">
        立即申请
      </nd-button>
    </div>
  </div>
</template>

<script>
import { setKey } from '@/assets/utils'

export default {
  data () {
    return {
      visible: true
    }
  },
  props: {
    caseId: {
      type: [String, Number],
      default: ''
    },
    data: {
      type: Object,
      default: () => ({})
    },
    isLogin: Boolean
  },
  methods: {
    open () {
      this.visible = true
      setKey('SUPREME_VIP_SHOW_TIME', Date.now())
    },
    close () {
      this.visible = false
      this.$emit('close')
    },
    handleButtonClick () {
      this.jumpToKingCardPage()
    },
    show () {
      this.isLogin && setKey('SUPREME_VIP_SHOW_TIME', Date.now())
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.supreme-vip-dialog {
  .supreme-vip-content {
    width: 620px;
    height: 750px;
    // background: url(./images/supreme_vip_bg.png) no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    .apply-btn {
      position: relative;
      top: 531px;
      width: 440px;
      height: 80px;
      margin: 0 auto;
      font-size: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 50px;
    }
  }
}
</style>